<template>
	<div style="background:#eee;padding: 5px">
		<Card :bordered="false">

			<p slot="title">
				<Icon type="md-call" />
				联系我们
			</p>

			<p>服务邮箱：2431886055@qq.com </p>
		<!-- 	<img   :src="require('@/assets/image/other/q1.png')"> -->
			<p>qq群：743198808 </p>
		</Card>
	</div>
</template>


<script>
	export default {
		name: 'ContacUs',
		components: {

		},
		data() {
			return {
				test: true,
			}
		},


	}
</script>

<style lang="scss">

</style>
